// PATHS
import axios from "axios";
import {UpdateApplicationRequest} from "../searchms/model";

const UPDATE_APPLICATION = '/network/application/update';
const SEND_TO_AUTHORITIES_DOCUMENTS = '/network/application/sendAuthorities';
const UPLOAD_DOCUMENT =  '/network/documents';
const DELETE_DOCUMENT =  '/network/documents/delete';
const GET_APPLICATION_BY_ID =  '/network/ms-application/findApplicationById';

const updateApplication: any = async (req: UpdateApplicationRequest) => {
    const response = await axios.post(UPDATE_APPLICATION, req);
    return response.data;
}

const uploadDocument: any = async (req: any) => {
    const response = await axios.post(UPLOAD_DOCUMENT, req);
    return response.data;
}

const deleteDocument: any = async (req: any) => {
    const response = await axios.delete(DELETE_DOCUMENT, {data:req});
    return response.data;
}

const getApplicationById: any = async (req:any) => {
    const response = await axios.post(GET_APPLICATION_BY_ID, req);
    return response.data;
}

const sendCheckedDocument: any = async (req:any) => {
    const response = await axios.post(SEND_TO_AUTHORITIES_DOCUMENTS, req);
    return response.data;
}

export {
    updateApplication,
    uploadDocument,
    deleteDocument,
    getApplicationById,
    sendCheckedDocument
}